export default "__VITE_ASSET__a1bdb94c__"